import { useEffect, useState, useCallback } from "react";
import { ScrollText, Eye } from "lucide-react";
import { adminFetch } from "@/lib/api";
import { Loader, Card, EmptyState } from "@/components/common";

const ACTION_LABEL = { impersonate: "Visualizza come utente", delete_user: "Eliminazione utente" };

export default function AdminAuditLog() {
  const [items, setItems] = useState([]);
  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [action, setAction] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (q) params.set("q", q);
      if (action) params.set("action", action);
      if (dateFrom) params.set("date_from", dateFrom);
      if (dateTo) params.set("date_to", dateTo);
      const res = await adminFetch(`/admin/audit-logs?${params.toString()}`);
      setItems(res.items || []);
      setActions(res.actions || []);
    } catch {
      /* ignore */
    } finally {
      setLoading(false);
    }
  }, [q, action, dateFrom, dateTo]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  const fld = "min-h-[42px] rounded-xl border border-border bg-card px-3 text-sm outline-none focus:border-primary";

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        <input data-testid="admin-audit-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca email admin/utente..." className={`col-span-2 ${fld} sm:col-span-1`} />
        <select data-testid="admin-audit-action" value={action} onChange={(e) => setAction(e.target.value)} className={fld}>
          <option value="">Tutte le azioni</option>
          {actions.map((a) => <option key={a} value={a}>{ACTION_LABEL[a] || a}</option>)}
        </select>
        <input data-testid="admin-audit-from" type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className={fld} />
        <input data-testid="admin-audit-to" type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className={fld} />
      </div>

      {loading ? (
        <Loader />
      ) : items.length === 0 ? (
        <EmptyState icon={ScrollText} title="Nessun log" text="Nessuna azione registrata per i filtri selezionati." />
      ) : (
        items.map((log, i) => (
          <Card key={log.id || i} data-testid={`admin-audit-${log.id || i}`} className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-secondary">
              <Eye className="h-5 w-5 text-primary" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-[14px] font-extrabold text-foreground">
                {ACTION_LABEL[log.action] || log.action}
              </p>
              <p className="truncate text-[12px] text-muted-foreground">
                Admin <strong>{log.admin_email || "—"}</strong> → utente <strong>{log.target_email || "—"}</strong>
                {log.action === "delete_user" && log.cascade ? ` · ${log.trips_deleted || 0} viaggi, ${log.missions_deleted || 0} missioni eliminati` : ""}
              </p>
            </div>
            <span className="shrink-0 text-[12px] text-muted-foreground">
              {String(log.created_at || "").slice(0, 16).replace("T", " ")}
            </span>
          </Card>
        ))
      )}
    </div>
  );
}
